/*
  © 2025 KondaSoft
  https://www.kondasoft.com
*/

/*
  Cart collapses - scroll to element
*/
window.ksCartDrawerFixScrollPosition = () => {
  setTimeout(() => {
    const wrapper = document.querySelector(".ks-cart-drawer-wrapper");
    wrapper.scroll({ top: wrapper.scrollHeight, behavior: "smooth" });
  }, 250);
};

/*
  Cart goal
*/
class KsCartGoal extends HTMLElement {
  constructor() {
    super();

    this.progressBar = this.querySelector(".bs-progress-bar");
    this.animateProgressBar();
    this.initConfetti();
  }

  animateProgressBar() {
    setTimeout(() => {
      this.progressBar.style.width = this.progressBar.dataset.width;
    }, 250);
  }

  async initConfetti() {
    if (this.dataset.showConfetti === "false") return;

    const goalCompleted = Number(this.dataset.goalCompleted);
    const prevGoalCompleted = Number(
      localStorage.getItem("ks-cart-goal-completed") || 0
    );

    if (prevGoalCompleted !== goalCompleted) {
      localStorage.setItem("ks-cart-goal-completed", goalCompleted);
    }

    if (goalCompleted <= prevGoalCompleted) return;

    const myCanvas = document.createElement("canvas");
    myCanvas.setAttribute("id", "ks-cart-goal-confetti-canvas");

    if (this.closest(".cart-drawer")) {
      this.closest(".cart-drawer")
        .querySelector(".drawer__inner")
        .insertAdjacentElement("afterbegin", myCanvas);
    }

    const myConfetti = window.confetti.create(myCanvas);

    myConfetti({
      particleCount: 400,
      spread: 90,
    });

    setTimeout(() => {
      myCanvas.remove();
    }, 4000);
  }
}
customElements.define("ks-cart-goal", KsCartGoal);

/*
  Cart upsells
*/
class KsCartUpsells extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('select[name="id"]').forEach((select) => {
      select.addEventListener("change", (event) => {
        event.preventDefault();
        const imgSrc = select.options[select.selectedIndex].dataset.variantImg;

        if (imgSrc) {
          const img = select
            .closest(".ks-cart-upsell-item")
            .querySelector(".ks-cart-upsell-item-image img");
          img.src = imgSrc;
        }
      });
    });

    setTimeout(() => {
      this.querySelectorAll("form").forEach((form) => {
        form.style.display = "block";
      });
    }, 2000);
  }
}
customElements.define("ks-cart-upsells", KsCartUpsells);

/*
  Cart discount form
*/
class KsCartDiscountForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.btn = this.querySelector("button");
    this.btn.addEventListener("click", this.onSubmit.bind(this));
  }

  async onSubmit() {
    this.btn.classList.add("loading");
    this.btn.querySelector(".loading__spinner").classList.remove("hidden");

    await fetch(
      `${window.Shopify.routes.root_url}discount/${this.input.value}`
    );
    window.location.href = "/checkout";

    setTimeout(() => {
      this.btn.classList.remove("loading");
      this.btn.querySelector(".loading__spinner").classList.add("hidden");
    }, 2000);
  }
}
customElements.define("ks-cart-discount-form", KsCartDiscountForm);
